import { Spinner } from './ui/spinner';

interface LoadingFallbackProps {
  message?: string;
}

/**
 * Loading fallback component for lazy-loaded routes
 * Shows a centered spinner with optional message
 */
export function LoadingFallback({ message }: LoadingFallbackProps) {
  return (
    <div className="flex h-screen w-full items-center justify-center">
      <div className="flex flex-col items-center gap-4">
        <Spinner className="size-8" />
        {message && <p className="text-sm text-gray-600 dark:text-gray-400">{message}</p>}
      </div>
    </div>
  );
}
